import React, {useEffect} from "react";
import {View} from "@unibuddy/patron";
import {useBooleanFeatureFlag} from "ub-feature-flagging-react";

import {SHOW_INTERSTITIAL_PAGE_HEADER} from "shared/constants";
import useAnalytics from "shared/AnalyticsNew/hooks/useAnalytics";
import {sharedEvents} from "shared/AnalyticsNew/constants/productSpecification";
import {IntroPageCardsContainer} from "../components/IntroPageCardsContainer";
import {IntroPageHeader} from "../components/IntroPageHeader";
import {useUniversity} from "../../UniversityProvider/UniversityProvider";

export function IntroPage({
    setUserHasSeenIntroPage,
}: {
    setUserHasSeenIntroPage: (b: boolean) => void;
}) {
    const {trackEvent} = useAnalytics();
    const {slug} = useUniversity();
    const showIntroPageHeader = useBooleanFeatureFlag(
        SHOW_INTERSTITIAL_PAGE_HEADER.key,
        SHOW_INTERSTITIAL_PAGE_HEADER.value,
    );

    useEffect(() => {
        if (slug) {
            trackEvent(sharedEvents.introPageOpened.name, {
                universitySlug: slug,
            });
        }

        const eventListener = (e: Event) => {
            if (!slug) return;
            if (!e || !(e instanceof MessageEvent)) return;
            if (e.data.type !== "productVisible") return;

            trackEvent(sharedEvents.introPageVisible.name, {
                universitySlug: slug,
                visibleTimeInMs: e.data.visibleTimeInMs ?? 0,
                visiblePercentage: e.data.visiblePercentage ?? 0,
            });
        };

        window.addEventListener("message", eventListener);

        return () => window.removeEventListener("message", eventListener);
    }, [slug, trackEvent]);

    return (
        <View gap="large" paddingY={["medium", "large", "xlarge"]}>
            {showIntroPageHeader ? <IntroPageHeader /> : null}
            <IntroPageCardsContainer setUserHasSeenIntroPage={setUserHasSeenIntroPage} />
        </View>
    );
}
